import {
  ContingencyPlanType,
  Step2Response,
  RecommendationCreate,
  CreateStep2Body,
} from "../../../types/cto/step2";
import {} from "../../../types/cto/ctoTypes";
import { StatusTypes } from "../../../types/statusTypes";
import { MOCK_LONG_TEXT, MOCK_SCE_CODE } from "../genericMocks";
import { mockUser } from "../user";

export const dataStep2Body: CreateStep2Body = {
  assigning_recommendations: [
    {
      additional_mitigation_needed: true,
      due_date: "2023-08-23T00:00:00.000Z",
      permanent_change: true,
      potential_consequences_changed: true,
      recommendation: MOCK_LONG_TEXT,
      user_id: mockUser.user_id,
      has_action_to_be_closed: null,
      temporary_due_date: null,
    },
  ],
  contingency_plan: {
    contingency_plan_code: "CT:MV24-1234",
    description: MOCK_LONG_TEXT,
  },
  potential_consequences_affected: "string",
  potential_consequences_associated_comment: "string",
  risk_level: 1,
  risk_level_files: [],
  assigning_recommendation_files: [],
  mopo_reviewed: null,
  is_issue_managed_in_other_system: null,
  issue_id_in_other_system: null,
  risk_level_after_measures: 1,
  risk_level_after_measures_comment: MOCK_LONG_TEXT,
  risk_level_after_measures_files: [],
  step_approved_at: null,
  step_approved_by: null,
  draft: false,
};

//REFACTOR TEST: Usar mocks da demo nos testes
export const mockCtoStep2Response: Step2Response = {
  approvals: [
    {
      approved: true,
      user: {
        position: "position 1",
        name: "User 1",
        mail: "user1@gmail.com",
        user_id: 1,
      },
      comments: "Approved comment",
    },
    {
      approved: false,
      user: {
        position: "position 2",
        name: "User 2",
        mail: "user2@gmail.com",
        user_id: 2,
      },
      comments: "Rejected comment",
    },
  ],
  assigning_recommendations: [],
  potential_consequences_associated: [],
  potential_consequences_associated_comment: "",
  contingency_plan: {
    contingency_plan_code: "1",
  },
  created_at: new Date(),
  created_by: {
    user_id: 1,
    name: "User",
    mail: "user@gmail.com",
    position: "manager",
  },
  cto_code: "CTO-MV24-23-0015",
  potential_consequences_affected: "",
  risk_level: 1,
  risk_level_files: [],
  assigning_recommendation_files: [],
  sces: [
    {
      sce_code: MOCK_SCE_CODE,
      sce_name: "Active Fire Protection - Firewater, Deluge",
      status: StatusTypes.critical,
    },
  ],
  can_user_fill_step: true,
  mopo_reviewed: null,
  is_issue_managed_in_other_system: null,
  issue_id_in_other_system: null,
  risk_level_after_measures: 1,
  risk_level_after_measures_comment: "",
  risk_level_after_measures_files: [],
  step_approved_at: null,
  step_approved_by: null,
  draft: false,
};

export const mockContingencyPlan: ContingencyPlanType = {
  contingency_plan_code: "CTO-MV00-23-1234-CP00024",
  description:
    "A partial loss of SCE function in a F&G Zone due to failure or unavailability of one F&G Detector longer than 72hrs A partial loss of SCE function in a F&G Zone due to failure or unavailability of one F&G Detector longer than 72hr",
};

export const contingencyPlanList: ContingencyPlanType[] = [
  mockContingencyPlan,
  {
    contingency_plan_code: "CTO-MV00-23-1234-CP00025",
    description: MOCK_LONG_TEXT,
  },
];

export const recommendation: RecommendationCreate = {
  additional_mitigation_needed: true,
  due_date: "2023-08-23",
  permanent_change: true,
  potential_consequences_changed: true,
  recommendation: MOCK_LONG_TEXT,
  user_id: mockUser.user_id,
};
